export default __webpack_public_path__ + "static/media/logomuni.0dc6e8c7.WebP";